import { YStack, YStackProps } from '@mythical/ui'

export type FullScreenOverlayProps = {
  asOverlay?: boolean
  children?: React.ReactNode
} & YStackProps

export const FullScreenOverlay = (props: FullScreenOverlayProps) => {
  const { asOverlay = true, children, ...wrapperProps } = props
  return (
    <YStack
      pos={asOverlay ? 'absolute' : 'relative'}
      f={1}
      height="100%"
      width="100%"
      ai="center"
      jc="center"
      py="$6"
      px="$3.5"
      top={0} left={0} right={0} bottom={0}
      {...wrapperProps}
    >
      {children}
    </YStack>
  )
}
